export default "__VITE_ASSET__fcdb9dea__"